'use client'

import Link from '@/components/client/seo/link'
import { PublicStyles } from '@/components/server/styles/public-styles'
import { useTranslation } from '@/hooks/client/use-translation'

// This not-found is rendered inside the [segment]/layout.tsx which already
// provides ServerNav, ClientProvider, and I18nProvider. Duplicating them here
// causes the full nav RSC payload to be embedded twice in every page.
export default function NotFound() {
  const { t } = useTranslation()
  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center gap-6 px-4 py-16">
      <PublicStyles />
      <h1 className="text-navy text-6xl font-bold">404</h1>
      <p className="text-navy-60 text-center text-xl">
        {t('notFound.message', "Sorry, we can't seem to find that page!")}
      </p>
      <Link
        data-tracking="ignore"
        href="/"
        className="bg-lapis hover:bg-navy rounded-full px-6 py-3 text-white transition-colors"
      >
        {t('notFound.goHome', 'Go back home')}
      </Link>
    </main>
  )
}
